export default class CustomStack {
    private items;
    private pointer;
    constructor() {
        this.items = {};
        this.pointer = 0; // 栈顶指针
    }

    push(element) {
        this.items[this.pointer] = element;
        this.pointer++;
    }

    pop() {
        if (this.pointer === 0) return "栈已空";
        this.pointer--;
        const element = this.items[this.pointer];
        delete this.items[this.pointer];
        return element;
    }

    peek() {
        return this.items[this.pointer - 1];
    }

    isEmpty() {
        return this.pointer === 0;
    }

    size() {
        return this.pointer;
    }

    clear() {
        this.items = {};
        this.pointer = 0;
    }
}
